export default "__VITE_ASSET__BaVvU0MS__"